"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createThemeMapper = void 0;
var _Select = require("./Select");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var createThemeMapper = exports.createThemeMapper = function createThemeMapper(icfTheme, size) {
  return function (theme) {
    var heightMap = {
      small: icfTheme.spacing.base * 4.5,
      medium: icfTheme.spacing.base * 5,
      large: icfTheme.spacing.base * 6
    };
    return _objectSpread(_objectSpread({}, theme), {}, {
      borderRadius: 2,
      colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
        primary: icfTheme.colors.primary,
        primary75: icfTheme.colors.primary,
        primary50: icfTheme.colors.primary,
        primary25: icfTheme.colors.baseContrast020,
        neutral0: icfTheme.colors.themeBase,
        neutral40: icfTheme.colors.primary,
        neutral80: icfTheme.colors.baseContrast080
      }),
      spacing: {
        baseUnit: 2,
        menuGutter: icfTheme.spacing.base / 2,
        controlHeight: heightMap[size]
      }
    });
  };
};
var styles = function styles(theme) {
  return {
    variables: _Select.selectVars.styles,
    root: {
      display: "flex",
      flexDirection: "column",
      fontFamily: theme.typography.fontFamily
    },
    lightBackground: {
      background: theme.colors.themeBase,
      borderRadius: 6
    },
    labelText: {
      color: theme.colors.baseContrast060,
      fontSize: theme.typography.fontSize - 1,
      zIndex: 2,
      lineHeight: 1.4,
      paddingBottom: theme.spacing.base / 2,
      fontSizes: _Select.selectVars.get("labelFontSize", 14)
    },
    errorText: {
      "p&": {
        fontFamily: "inherit",
        fontSize: theme.typography.fontSize - 1,
        color: theme.colors.alert,
        marginTop: theme.spacing.base / 2,
        fontWeight: 600,
        marginBottom: 0
      }
    },
    hint: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    description: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    select: {}
  };
};
var useSelectStyles = (0, _createUseStyles.default)(styles, {
  name: "Select"
});
var _default = exports.default = useSelectStyles;